
import { Component, Vue, Prop} from 'vue-property-decorator';

import PageBase from "../PageBase.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
        PageBase
    }
})
export default class DisclosureInformationFS extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    disableNextButton = false;
    showCopyDocsInfo = false;
    showTaxFilingInfo = false
    currentStep =0;
    currentPage =0;
    proofOfIncomeList = [];
    showProofOfIncomeList = false;
    showProofOfIncomeListKey = 0;
    corporation = null;
    incomeAcknowledgement = false;
    incomeProofAcknowledgement = false;
    otherIncomeProofDocs = "";
    
    created() {
        this.disableNextButton = false;       
    }

    mounted(){        
        this.reloadPageInformation();
    } 
    
    public reloadPageInformation() {    

        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;

        if (this.step.result?.disclosureInformationFSSurvey?.data) {

            const disclosureData = this.step.result.disclosureInformationFSSurvey.data;

            this.corporation = disclosureData.corporation;
            this.incomeProofAcknowledgement = disclosureData.incomeProofAcknowledgement;
            this.incomeAcknowledgement = disclosureData.incomeAcknowledgement;   
            this.otherIncomeProofDocs = disclosureData.otherIncomeProofDocs;           
            this.determineReadyToContinue();   
            Vue.filter('scrollToLocation')(this.$store.state.Application.scrollToLocationName);            
        } 

        if (this.step.result?.incomeInformationSurvey?.data?.incomeAmounts) {
            const incomeData = this.step.result?.incomeInformationSurvey.data.incomeAmounts;
            for(const incomeType of incomeData) {
                if(incomeType.income)
                    this.proofOfIncomeList.push(incomeType.incomeName);
            }
        }

        this.determineReadyToContinue();       

        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 50, false);
    }

    public updateCorporation(){ 
        this.determineReadyToContinue();       
        this.showProofOfIncomeListKey ++;        
    }

    public determineReadyToContinue(){       

        this.disableNextButton = this.corporation == null || !this.incomeAcknowledgement || 
                                !this.incomeProofAcknowledgement || 
                                (this.proofOfIncomeList.includes('other') && this.otherIncomeProofDocs.length==0);

    }   

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {        
        Vue.prototype.$UpdateGotoNextStepPage()
    }

    public getDisclosureResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        if(this.getDisclosureInfo()){

            const disclosureInfo = this.getDisclosureInfo();
            
            questionResults.push({
                name:'disclosureInformationFSSurvey', 
                value: disclosureInfo.incomeAcknowledgement?'I understand':'', 
                title: 'I am required to attach a copy of my documents from Canada Revenue Agency to my financial statement', inputType:''});

            questionResults.push({
                name:'disclosureInformationFSSurvey', 
                value: disclosureInfo.incomeProofAcknowledgement?'I understand':'', 
                title: 'I am required to attach a copy of my documents as proof of income from each source of my income to my financial statement', inputType:''});

            questionResults.push({
                name:'disclosureInformationFSSurvey', 
                value: disclosureInfo.corporation=='Yes'?'Yes':'No', 
                title: 'Do you control a corporation?', inputType:''});

            if(this.proofOfIncomeList.includes('other')){
                questionResults.push({
                    name:'disclosureInformationFSSurvey', 
                    value: disclosureInfo.otherIncomeProofDocs, 
                    title: 'What you are providing as proof of your other income?', inputType:''});
            }
            
        }  
        
        return {data: this.getDisclosureInfo(), questions:questionResults, pageName:'Disclosure of Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getDisclosureInfo(){

        let proofOfOtherIncome = this.proofOfIncomeList.includes('other')?this.otherIncomeProofDocs:"";        

        let result = {           
            incomeAcknowledgement: this.incomeAcknowledgement,
            corporation: this.corporation,
            incomeProofAcknowledgement: this.incomeProofAcknowledgement,
            otherIncomeProofDocs: proofOfOtherIncome
        }

        return result
    }
    
    beforeDestroy() {        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, true);        
        this.UpdateStepResultData({step:this.step, data: {disclosureInformationFSSurvey: this.getDisclosureResults()}})
    }
}
